import { authConstants } from 'constants/actionTypes'

const initialState = {
  account: null,
  error: null,
  idToken: null,
  accessToken: null,
  isAuthenticated: false,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case authConstants.UPDATE_ACCOUNT:
      return {
        ...state,
        account: action.payload,
        idToken: action.payload.idToken,
        isAuthenticated: true,
      }

    case authConstants.UPDATE_ERROR:
      return {
        ...state,
        error: action.payload,
        isAuthenticated: false,
      }

    case authConstants.UPDATE_TOKEN:
      return {
        ...state,
        accessToken: action.payload,
      }

    default:
      return state
  }
}
